import { render, staticRenderFns } from "./PurchaseRemitos.vue?vue&type=template&id=04032fe7&"
import script from "./PurchaseRemitos.vue?vue&type=script&lang=js&"
export * from "./PurchaseRemitos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports